<template>
  <div class="input-selector">
    <button
      v-for="option in options"
      type="button"
      :key="option.value"
      class="input-selector__button"
      :class="optionClass(option)"
      @click="buttonClick(option)">
     <slot v-bind:option="option">
       {{ option.label }}
     </slot>
    </button>
  </div>
</template>

<script>
export default {
  name: 'inputSelector',
  props: {
    value: {
      type: [Array, Boolean, Number, String],
    },
    options: {
      type: Array,
      default: () => [],
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    buttonClass: {
      type: String,
      default: '',
    },
  },
  computed: {
    valueSync: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('change', value);
        this.$emit('input', value);
      },
    },
  },
  methods: {
    buttonClick(option) {
      if (this.multiple) {
        if (this.valueSync.includes(option.value)) {
          this.valueSync = this.valueSync.filter(value => value !== option.value);
        } else {
          this.valueSync = [...this.valueSync, option.value];
        }
      } else {
        this.valueSync = option.value;
      }
    },
    isSelected(option) {
      return this.valueSync !== undefined
        && this.valueSync !== null
        && (
          this.valueSync === option.value
          || (Array.isArray(this.valueSync) && this.valueSync.includes(option.value)));
    },
    optionClass(option) {
      return {
        'input-selector__button--selected': this.isSelected(option),
        [this.buttonClass]: true,
      };
    },
  },
};
</script>

<style scoped lang="scss">
.input-selector {
  display: flex;
  flex-wrap: wrap;
  margin: -10px;
  &__button {
    place-content: center;
    padding: 15px;
    font-size: $--font-size-small;
    min-height: 42px;
    margin: 10px;
    cursor: pointer;
    background: transparent;
    border: 0.5px solid $--color-secondary;
    color: $--color-secondary;
    border-radius: $--border-radius-base;
    outline: none;
    flex: none;

    @include breakpoint(mobile){
      font-size: $--font-size-small;
    }

    &--selected {
      border: 1px solid $--color-primary;
      color: $--color-text-primary;
      background-color: rgba(28, 219, 161, 0.1);
      text-shadow: $--text-shadow-default;
    }
    &--no-wrap {
      white-space: nowrap;
    }
  }
}
</style>
